/* Full-screen blocker shown when the backend is unreachable on boot or
 * goes away mid-session. Polls /health until it's back, then unmounts itself. */

import { useEffect, useState } from 'react';
import { pingHealth } from '../api/client.js';
import { Button } from '../components.jsx';
import { Icon } from '../icons.jsx';
import { VilkaMark } from '../mark.jsx';

export function BackendGate({ onRecovered }) {
  const [retrying, setRetrying] = useState(false);
  const [tries, setTries] = useState(0);

  const tryNow = async () => {
    if (retrying) return;
    setRetrying(true);
    try {
      await pingHealth();
      onRecovered();
    } catch { /* still down */ }
    setRetrying(false);
    setTries((t) => t + 1);
  };

  // Slow background retry every 5s so the gate dissolves on its own when
  // the backend comes back, without forcing the user to click.
  useEffect(() => {
    const id = setInterval(() => { tryNow(); }, 5000);
    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        background: 'var(--t-white)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        gap: 24, padding: 24, textAlign: 'center',
      }}
      role="alert"
      aria-live="polite"
    >
      <VilkaMark variant="yellow-square" size={88} anim="breathe" />
      <div style={{ maxWidth: 420 }}>
        <h1 className="t-h2" style={{ margin: '0 0 8px' }}>Сервис временно недоступен</h1>
        <p className="t-body t-muted" style={{ margin: 0 }}>
          Не получается достучаться до бэкенда. Мы автоматически пробуем снова раз в несколько секунд.
        </p>
      </div>
      <Button
        variant="primary"
        icon={retrying ? 'spinner' : 'refresh'}
        onClick={tryNow}
        disabled={retrying}
      >
        {retrying ? 'Проверяем…' : 'Попробовать сейчас'}
      </Button>
      {tries > 0 && (
        <div className="t-body-s t-muted" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          <Icon name="alert" size={14} />
          Попыток: {tries}
        </div>
      )}
    </div>
  );
}
